import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-7974">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-7975">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-7976">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-7977">
            <ArrowLeft className="w-4 h-4" data-id="element-7978" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-7979">NOIZA</div>
          <div className="w-20" data-id="element-7980" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-7981">
        <div className="mb-12" data-id="element-7982">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-7983">
            <FileText className="w-6 h-6 text-white/80" data-id="element-7984" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-7985">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-7986">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-7987">
          <section data-id="element-7988">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7989">
              <span className="text-[#006847]" data-id="element-7990">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-7991">
              <p data-id="element-7992">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-7993">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7994">
                <li data-id="element-7995">Haber leído íntegramente este documento</li>
                <li data-id="element-7996">Comprender su contenido en su totalidad</li>
                <li data-id="element-7997">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-7998">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-7999">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8000">
              <span className="text-[#006847]" data-id="element-8001">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8002">
              <p data-id="element-8003">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8004">
                <li data-id="element-8005">Software como servicio (SaaS)</li>
                <li data-id="element-8006">Marketplace digital gastronómico</li>
                <li data-id="element-8007">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-8008">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8009">
                <li data-id="element-8010">Mostrar su menú digital</li>
                <li data-id="element-8011">Recibir pedidos de clientes</li>
                <li data-id="element-8012">Gestionar su operación interna</li>
                <li data-id="element-8013">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-8014">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-8015">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8016">
              <span className="text-[#006847]" data-id="element-8017">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8018">
              <p data-id="element-8019">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8020">
                <li data-id="element-8021">No es proveedor de alimentos</li>
                <li data-id="element-8022">No participa en la preparación de productos</li>
                <li data-id="element-8023">No manipula alimentos en ningún momento</li>
                <li data-id="element-8024">No realiza entregas ni logística</li>
                <li data-id="element-8025">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-8026">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-8027">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-8028">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8029">
              <span className="text-[#006847]" data-id="element-8030">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-8031">
              <p data-id="element-8032">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-8033">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8034">
                <li data-id="element-8035">El restaurante es el único responsable de su operación</li>
                <li data-id="element-8036">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-8037">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-8038">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8039">
                <li data-id="element-8040">Precios</li>
                <li data-id="element-8041">Menú</li>
                <li data-id="element-8042">Horarios</li>
                <li data-id="element-8043">Métodos de pago</li>
                <li data-id="element-8044">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8045">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8046">
              <span className="text-[#006847]" data-id="element-8047">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-8048">
              <div data-id="element-8049">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8050">
                  5.1. Alcance general
                </h3>
                <p data-id="element-8051">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-8052">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8053">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-8054">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8055">
                  <li data-id="element-8056">Calidad de los alimentos</li>
                  <li data-id="element-8057">Estado, frescura o preparación</li>
                  <li data-id="element-8058">Ingredientes utilizados</li>
                  <li data-id="element-8059">Contaminación cruzada</li>
                  <li data-id="element-8060">Problemas de higiene o salubridad</li>
                  <li data-id="element-8061">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8062">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-8063">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8064">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-8065">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8066">
                  <li data-id="element-8067">Retrasos en la entrega</li>
                  <li data-id="element-8068">Pérdida de pedidos</li>
                  <li data-id="element-8069">Entregas incompletas</li>
                  <li data-id="element-8070">Errores en dirección</li>
                  <li data-id="element-8071">Conducta de repartidores</li>
                  <li data-id="element-8072">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-8073">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8074">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-8075">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-8076">
                  <li data-id="element-8077">Recepción de pagos</li>
                  <li data-id="element-8078">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-8079">Manejo de efectivo</li>
                  <li data-id="element-8080">Confirmación de pagos</li>
                  <li data-id="element-8081">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-8082">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8083">
                  <li data-id="element-8084">Pagos no recibidos</li>
                  <li data-id="element-8085">Comprobantes falsos</li>
                  <li data-id="element-8086">Errores en montos</li>
                  <li data-id="element-8087">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-8088">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8089">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-8090">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8091">
                  <li data-id="element-8092">Reclamos de clientes</li>
                  <li data-id="element-8093">Reembolsos</li>
                  <li data-id="element-8094">Cancelaciones</li>
                  <li data-id="element-8095">Disputas</li>
                  <li data-id="element-8096">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8097">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-8098">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8099">
              <span className="text-[#006847]" data-id="element-8100">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-8101">
              <p data-id="element-8102">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8103">
                <li data-id="element-8104">Responsable</li>
                <li data-id="element-8105">Legal</li>
                <li data-id="element-8106">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-8107">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8108">
                <li data-id="element-8109">Publicar información falsa</li>
                <li data-id="element-8110">Manipular precios de forma engañosa</li>
                <li data-id="element-8111">Simular disponibilidad inexistente</li>
                <li data-id="element-8112">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8113">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8114">
              <span className="text-[#006847]" data-id="element-8115">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-8116">
              <p data-id="element-8117">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8118">
                <li data-id="element-8119">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-8120">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-8121">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8122">
                <li data-id="element-8123">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-8124">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-8125">
                    <li data-id="element-8126">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-8127">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-8128">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8129">
              <span className="text-[#006847]" data-id="element-8130">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-8131">
              <p data-id="element-8132">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8133">
                <li data-id="element-8134">Menú digital</li>
                <li data-id="element-8135">Gestión de pedidos</li>
                <li data-id="element-8136">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-8137">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8138">
                  <p className="font-medium text-white mb-2" data-id="element-8139">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8140">
                    <li data-id="element-8141">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8142">
                  <p className="font-medium text-white mb-2" data-id="element-8143">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8144">
                    <li data-id="element-8145">Propiedad del software</li>
                    <li data-id="element-8146">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-8147">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-8148">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8149">
              <span className="text-[#006847]" data-id="element-8150">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8151">
              <p data-id="element-8152">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8153">
                <li data-id="element-8154">Disponibilidad continua</li>
                <li data-id="element-8155">Funcionamiento sin interrupciones</li>
                <li data-id="element-8156">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-8157">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8158">
                <li data-id="element-8159">Fallas técnicas</li>
                <li data-id="element-8160">Actualizaciones</li>
                <li data-id="element-8161">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-8162">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-8163">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8164">
              <span className="text-[#006847]" data-id="element-8165">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-8166">
              <p data-id="element-8167">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8168">
                <li data-id="element-8169">No está garantizada permanentemente</li>
                <li data-id="element-8170">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-8171">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8172">
                <li data-id="element-8173">Destacar o no restaurantes</li>
                <li data-id="element-8174">Modificar posiciones</li>
                <li data-id="element-8175">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8176">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8177">
              <span className="text-[#006847]" data-id="element-8178">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-8179">
              <p data-id="element-8180">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8181">
                <li data-id="element-8182">Cumplir con los pagos acordados</li>
                <li data-id="element-8183">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-8184">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8185">
                <li data-id="element-8186">Suspender el servicio</li>
                <li data-id="element-8187">Limitar funcionalidades</li>
                <li data-id="element-8188">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8189">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8190">
              <span className="text-[#006847]" data-id="element-8191">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8192">
              <p data-id="element-8193">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8194">
                <li data-id="element-8195">Incumplimiento de términos</li>
                <li data-id="element-8196">Uso indebido</li>
                <li data-id="element-8197">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-8198">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-8199">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8200">
              <span className="text-[#006847]" data-id="element-8201">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-8202">
              <p data-id="element-8203">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-8204">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-8205">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8206">
              <span className="text-[#006847]" data-id="element-8207">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-8208">
              <p data-id="element-8209">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8210">
                <li data-id="element-8211">Pérdidas económicas</li>
                <li data-id="element-8212">Daños indirectos</li>
                <li data-id="element-8213">Lucro cesante</li>
                <li data-id="element-8214">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8215">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8216">
              <span className="text-[#006847]" data-id="element-8217">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-8218">
              <p data-id="element-8219">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-8220">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8221">
              <span className="text-[#006847]" data-id="element-8222">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-8223">
              <p className="font-medium" data-id="element-8224">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-8225">
                <li data-id="element-8226">Ha leído este documento completo</li>
                <li data-id="element-8227">Comprende su alcance</li>
                <li data-id="element-8228">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}